module.exports = __webpack_public_path__ + "static/Rapsody-1db61fd5ea90cb992686b4b5304a4305.png";